import React, { useEffect, useState } from "react";
import { MdHelpCenter, MdScatterPlot, MdStackedLineChart, MdSettings, MdSupportAgent } from "react-icons/md";
import { Toolbar, List, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { MdClearAll } from "react-icons/md";
import { useBackendStatusContext } from "../../context/backendStatus/backendStatusContext";
import { useTranslation } from "../../context/TranslationContext";
import logo200ImageWhite from "../../images/logo_white.png";
import SourceLink from "../SourceLink";
import { useSidebar } from "../../context/SidebarContext";
import { SidebarContainer, SidebarContent, SidebarBackground, StyledNavLink, SidebarListText, SidebarNavItemIcon, LogoWrapper, StyledIconButton } from "../../constants/styledComponents";

const basicNavItems = [
	{ to: "/support", name: "navItems.support", Icon: MdSupportAgent },
	{ to: "/about", name: "navItems.about", Icon: MdHelpCenter },
];

const extendedNavItems = [
	{ to: "/", name: "navItems.visualTests", Icon: MdScatterPlot },
	{ to: "/results", name: "navItems.results", Icon: MdStackedLineChart },
	{ to: "/settings", name: "navItems.settings", Icon: MdSettings },
	{ to: "/support", name: "navItems.support", Icon: MdSupportAgent },
	{ to: "/about", name: "navItems.about", Icon: MdHelpCenter },
];

const getNavItems = (translate, isExtended) => {
	const items = isExtended ? extendedNavItems : basicNavItems;
	return items.map(item => ({ ...item, name: translate(item.name) }));
};

const Sidebar = () => {
	const backendStatus = useBackendStatusContext();
	const { translate } = useTranslation();
	const [isMobileSidebar, setIsMobileSidebar] = useState(window.innerWidth <= 768);

	const [navItems, setNavItems] = useState(getNavItems(translate, false));
	const { isSidebarOpen, closeSidebar } = useSidebar();


	useEffect(() => {
		setNavItems(extendedNavItems);
	}, []);
	const handleNavItemClick = () => {
		if (window.innerWidth <= 768) {
			closeSidebar();
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobileSidebar(window.innerWidth <= 768);
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

		
	useEffect(() => {
		const isExtended = backendStatus.state.status !== 'loading' || backendStatus.state.isAvailable || backendStatus.state.isUpdating;
		setNavItems(getNavItems(translate, isExtended));
	}, [backendStatus.state.isAvailable, backendStatus.state.isUpdating, backendStatus.state.status, translate]);

	return (
		<SidebarContainer isopen={isSidebarOpen} data-image={logo200ImageWhite}>
			<SidebarBackground />
			<SidebarContent>
				<AppBar position="static" sx={{ backgroundColor: "transparent" }} elevation={0}>
					<Toolbar display="flex" sx={{ justifyContent: "space-between" }}>
						<SourceLink style={{ display: "flex", textDecoration: "none" }}>
							<LogoWrapper>
								<img src={logo200ImageWhite} width="20" height="24" alt="" style={{ margin: "0px 8px 2px 6px" }} />
								<Typography variant="h6" style={{ fontWeight: "bold", fontSize: "22px" }}>SONDA</Typography>
							</LogoWrapper>
						</SourceLink>
						
						{isMobileSidebar && (
							<StyledIconButton onClick={closeSidebar} sx={{ border: '1px solid #fff', mr: 0 }}>
								<MdClearAll size={25} style={{ color: "white" }} />
							</StyledIconButton>
						)}
					</Toolbar>
				</AppBar>
				<List>
					{navItems.map(({ to, name, Icon }, index) => (
						<StyledNavLink
							key={index}
							to={to}
							onClick={handleNavItemClick}
						>
							<SidebarNavItemIcon>
								<Icon style={{ color: "white", width: "24px", height: "24px" }} />
							</SidebarNavItemIcon>
							<SidebarListText primary={name} />
						</StyledNavLink>
					))}
				</List>
			</SidebarContent>
		</SidebarContainer>
	);
};

export default Sidebar;
